import { useEffect, useState } from 'react'

import { InjectionTokens } from '@/controller/tokens'

import { FeedbackCollectorFeature } from '../components/FeedbackCollectorFeature/FeedbackCollectorFeature'

import { LocalStorageKeyValuePersister } from '@/infra/keyValuePersister/LocalStorageKeyValuePersister'
import { useInjection } from '@/presentation/contexts/InjectionContext'
import { useBehaviorSubject } from '@/presentation/hooks/useBehaviorSubject'
import {
  ScreenElementsState,
  ScreenElementsStateMutator,
  ScreenElementsStateProps
} from '@/presentation/modules/MapScreen/states/ScreenElementsState'

function FeedbackCollectorFeaturePresenter() {
  const persister = useInjection<LocalStorageKeyValuePersister>(InjectionTokens.KeyValuePersister)
  const screenElementsState = useBehaviorSubject<ScreenElementsStateProps>(ScreenElementsState)

  const [showPassiveFeedback, setShowPassiveFeedback] = useState(false)

  useEffect(() => {
    const run = async () => {
      const result = await persister.get('show-passive-feedback')
      if (result.isSuccess) {
        if (result.getValue() === 'true') {
          setShowPassiveFeedback(true)
        } else {
          setShowPassiveFeedback(false)
        }
      } else {
        const setResult = await persister.set('show-passive-feedback', 'true')
        if (setResult.isSuccess) {
          setShowPassiveFeedback(true)
        }
      }
    }

    run()
  }, [])

  return (
    <FeedbackCollectorFeature
      passiveFeedbackEnabled={showPassiveFeedback}
      forceCompactButton={ScreenElementsStateMutator.getDrawerState() === 'expanded'}
      onDisablePassiveFeedback={() => {
        persister.set('show-passive-feedback', 'false')
        setShowPassiveFeedback(false)
      }}
    />
  )
}

export { FeedbackCollectorFeaturePresenter }
